export const validateURL = url => {
  if (!url || url.trim() === "") return false;
  
  // Remove protocol if present for validation
  const urlWithoutProtocol = url.replace(/^https?:\/\//, "");
  
  // Check if it's a valid domain (with or without path)
  const domainRegex = /^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/;
  return domainRegex.test(urlWithoutProtocol);
};
